import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { getAdminMe } from '../helper/apiKeysApi';

// Fragt das Backend, ob der angemeldete Nutzer Admin ist. Steuert nur, was die
// Oberfläche anbietet — jeder Admin-Endpunkt prüft die Berechtigung selbst.
// null: Antwort steht noch aus (sonst blitzte "kein Zugriff" kurz auf).
export default function useIsAdmin() {
  const { instance, accounts } = useMsal();
  const loggedIn = accounts.length > 0;
  const [isAdmin, setIsAdmin] = useState(null);

  useEffect(() => {
    if (!loggedIn) {
      setIsAdmin(false);
      return undefined;
    }
    let active = true;
    getAdminMe(instance)
      .then((data) => {
        if (active) setIsAdmin(Boolean(data?.is_admin));
      })
      .catch(() => {
        if (active) setIsAdmin(false);
      });
    return () => {
      active = false;
    };
  }, [instance, loggedIn]);

  return isAdmin;
}
